import { render, staticRenderFns } from "./BackofficeFormTypes.vue?vue&type=template&id=422500f6&scoped=true"
import script from "./BackofficeFormTypes.vue?vue&type=script&lang=js"
export * from "./BackofficeFormTypes.vue?vue&type=script&lang=js"
import style0 from "./BackofficeFormTypes.vue?vue&type=style&index=0&id=422500f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422500f6",
  null
  
)

export default component.exports